import * as React from 'react';
import { INumberField } from './interfaces';
import { TextField } from '@mui/material';

export const NumberField: React.FC<INumberField> = ({
  label,
  value,
  helperText,
  placeholder,
  error = false,
  required = false,
  onChange,
}): JSX.Element => {
  return (
    <TextField
      label={label}
      variant="outlined"
      type="number"
      size="small"
      value={value}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      required={required}
      inputProps={{
        inputMode: 'numeric',
        pattern: '[0-9]*',
      }}
      onChange={(e) => {
        if (!onChange) {
          return;
        }

        const value = e.target.value;

        if (/^\d*$/.test(value)) {
          onChange(e);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === '-' || e.key === ',' || e.key === '.' || e.key === 'e') {
          e.preventDefault();
        }
      }}
    />
  );
};
